import { render, staticRenderFns } from "./advice-info.vue?vue&type=template&id=15731007&scoped=true&"
import script from "./advice-info.vue?vue&type=script&lang=js&"
export * from "./advice-info.vue?vue&type=script&lang=js&"
import style0 from "./advice-info.vue?vue&type=style&index=0&id=15731007&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15731007",
  null
  
)

export default component.exports